import React from "react";
import { Theme, Typography } from "@mui/material";
import { toPercent } from "@helpers";

interface ContractChartTagProps {
  percent: number;
  theme: Theme;
  icon?: React.ReactNode;
}

export const IconValueTag = (props: ContractChartTagProps) => {
  const { percent, theme, icon } = props;

  const value = toPercent(percent / 100, "auto", 0, 0);

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        background: theme.palette.background.tooltipPrimary,
        color: theme.palette.text.onTooltipPrimary,
        borderRadius: "8px",
        padding: "10px 8px",
        gap: "9px",
      }}
    >
      <div
        className="label-icon"
        style={{
          height: "20px",
          width: "20px",
        }}
      >
        {icon}
      </div>

      <Typography variant="body3" style={{ margin: 0 }}>
        {value}
      </Typography>
    </div>
  );
};
